import { useTranslation } from 'react-i18next'
import { formatMoneyCents } from '@/shared/lib/formatMoney'
import { longStayHintLabel } from '@/shared/lib/propertyPriceLabels'
import type { LongStayDiscountHint } from '@/shared/schemas/longStayDiscountHint.schema'

export function useLongStayHintLabel(hint: LongStayDiscountHint | null | undefined, currency: string): string {
  const { t, i18n } = useTranslation()
  if (hint == null) {
    return ''
  }
  const locale = (i18n.resolvedLanguage ?? i18n.language).replaceAll('_', '-')

  return longStayHintLabel(t, hint, {
    money: (cents) => formatMoneyCents(cents, currency, locale),
    percent: (fraction) => new Intl.NumberFormat(locale, { style: 'percent', maximumFractionDigits: 2 }).format(fraction),
  })
}
